import {Component, Input} from '@angular/core';
import {WidgetModel} from '../../model/widget.model';

@Component({
    selector: 'app-crm-board-widget',
    templateUrl: './crm-board-widget.component.html',
    styleUrl: './crm-board-widget.component.scss'
})
export class AppCrmBoardWidgetComponent {
    @Input() widgetData: WidgetModel;
}